import { useState, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Input,
  CardHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { isEmpty } from "lodash";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  useSubscribers,
  useAdminSubscriptions,
  useSubscriptions,
  useSubscriptionTypes,
  usePricing,
} from "../../hooks/useAdministration";

const AbonnesFormule = (props) => {
  const subscribersQ = useSubscribers();
  const adminSubsQ = useAdminSubscriptions();
  const subsQ = useSubscriptions();
  const typeSubQ = useSubscriptionTypes();
  const pricingQ = usePricing();

  const abonnes = useMemo(() => subscribersQ.data || [], [subscribersQ.data]);
  const abonnement = useMemo(() => adminSubsQ.data || [], [adminSubsQ.data]);
  const sub = useMemo(() => subsQ.data || [], [subsQ.data]);
  const typesub = useMemo(() => typeSubQ.data || [], [typeSubQ.data]);
  const pricing = useMemo(() => pricingQ.data || [], [pricingQ.data]);

  const pricingtri = useMemo(() => {
    const Subtri = (j) => {
      for (let i = 0; i <= sub.length; i++) {
        if (j === sub[i]?.id) return sub[i]?.designation;
      }
    };
    const TypeSubTri = (j) => {
      for (let i = 0; i <= typesub.length; i++) {
        if (j === typesub[i]?.id) return typesub[i]?.designation;
      }
    };
    return pricing.map((pri) => ({
      ...pri,
      subscription: Subtri(pri.subscription),
      subscription_type: TypeSubTri(pri.subscription_type),
    }));
  }, [pricing, sub, typesub]);

  const abon = useMemo(() => {
    const AbonnementAbo = (j) => {
      for (let i = 0; i <= abonnes.length; i++) {
        if (j === abonnes[i]?.id) {
          return abonnes[i]?.first_name + " " + abonnes[i]?.last_name;
        }
      }
      return "";
    };
    const PricingLib = (j) => {
      for (let i = 0; i <= pricingtri.length; i++) {
        if (j === pricingtri[i]?.id) {
          return (
            pricingtri[i]?.subscription + " " + pricingtri[i]?.subscription_type
          );
        }
      }
    };
    return abonnement.map((abo) => ({
      ...abo,
      abonne: AbonnementAbo(abo.abonne),
      pricing: PricingLib(abo.pricing),
      abonneid: abo.abonne,
    }));
  }, [abonnement, abonnes, pricingtri]);

  const [abontri, setAbonTri] = useState([]);

  const handleabontri = (e) => {
    if (isEmpty(e.target.value)) {
      setAbonTri([]);
    } else {
      if (e.target.value === "1") {
        setAbonTri(abon.filter((abo) => abo.pricing === "TRIAL Essentiel"));
      } else {
        setAbonTri(abon.filter((abo) => abo.pricing !== "TRIAL Essentiel"));
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: props.t("No."),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">{abo.row.index + 1}</h5>
              </div>
            </div>
          </>
        ),
        filterable: false,
      },
      {
        Header: props.t("Abonnés"),
        accessor: "abonne",
        Cell: (abo) => (
          <>
            <Link
              to={`/admin-abonne-detail/${abo.row.original.abonneid}/`}
              className="text-warning d-inline-block"
            >
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="fs-14 mb-1">{abo.row.original.abonne}</h5>
                </div>
              </div>
            </Link>
          </>
        ),
        filterable: false,
      },
      {
        Header: props.t("Abonnement"),
        accessor: "pricing",
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.pricing === "TRIAL Essentiel"
                    ? "Essai gratuit"
                    : abo.row.original.pricing}
                </h5>
              </div>
            </div>
          </>
        ),
        filterable: false,
      },
      {
        Header: props.t("Debut"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">{abo.row.original.start}</h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Fin"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">{abo.row.original.end}</h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Affilié"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.affilie === null
                    ? "Non-affilié"
                    : abo.row.original.affilie}
                </h5>
              </div>
            </div>
          </>
        ),
      },
    ],
    [],
  );

  document.title = props.t("Liste des abonnés | Le Conseiller du BTP");

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      <Container fluid>
        <BreadCrumb
          title={props.t("Abonnés")}
          pageTitle={props.t("Liste des abonnés")}
        />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <Col lg={7}>
                  <div className="d-flex align-items-center">
                    <Label for="abontri">{props.t("Filtrer par")} :</Label>
                    <Input
                      className="form-control"
                      type="select"
                      style={{ marginLeft: "10px", width: "200px" }}
                      onChange={(e) => {
                        handleabontri(e);
                      }}
                    >
                      <option value="">{props.t("Abonnement")}</option>
                      <option value="1">{props.t("Essai Gratuit")}</option>
                      <option value="2">{props.t("Abonnement payant")}</option>
                    </Input>
                  </div>
                </Col>
              </CardHeader>
            </Card>
            <Card id="orderList">
              <CardBody className="pt-0">
                <div>
                  {abonnement && abonnement.length > 0 ? (
                    isEmpty(abontri) ? (
                      <TableContainer
                        columns={columns}
                        data={abon || []}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={25}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                      />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={abontri || []}
                        isAddUserList={false}
                        customPageSize={25}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                      />
                    )
                  ) : (
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/msoeawqm.json"
                          trigger="loop"
                          colors="primary:#405189,secondary:#0ab39c"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>

                      <div className="mt-4">
                        <h5>{props.t("Sorry! No Result Found")}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

AbonnesFormule.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(AbonnesFormule));
